import { useEffect, useState } from "react";
import app from "nystem";
import { useLanguage } from "nystem-components";

const PartCookieBanner = () => {
  const lang = useLanguage();
  const [consent, setConsent] = useState("loading");
  const [language, setLanguage] = useState({});

  useEffect(() => {
    app.storage.getItem({ id: "cookieConsent" }).then(({ value }) => {
      if (value === "granted") window.consentGrantedAdStorage();
      setConsent(value);
    });
  }, []);

  useEffect(() => {
    if (consent || !lang) return;
    app.database.language.get({ id: lang }).then(({ data }) => setLanguage(data || {}));
  }, [consent, lang]);

  if (consent) return null;

  const choose = (value) => {
    app.storage.setItem({ id: "cookieConsent", value });
    if (value === "granted") window.consentGrantedAdStorage();
    setConsent(value);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookies"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-[#c9bfb1] bg-[#f7f4ef] p-4 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
        <p className="text-sm text-gray-700 sm:grow">
          {language.cookieText ||
            "Vi använder cookies för att se hur webbplatsen används, så att vi kan göra den bättre."}
        </p>
        <div className="grid grid-cols-2 gap-2 sm:w-72 sm:shrink-0">
          <button
            type="button"
            className="rounded border border-[#c9bfb1] bg-[#ece7df] px-4 py-2 text-sm text-[#3f3a33] hover:bg-[#e3dccf]"
            onClick={() => choose("denied")}
          >
            {language.cookieReject || "Avböj"}
          </button>
          <button
            type="button"
            className="rounded border border-[#c9bfb1] bg-[#ece7df] px-4 py-2 text-sm text-[#3f3a33] hover:bg-[#e3dccf]"
            onClick={() => choose("granted")}
          >
            {language.cookieApprove || "Godkänn"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartCookieBanner;
